// src/hooks/useAPI.js

import { useEffect, useState } from 'react';
import api from '../api/axios';

const useAPI = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!url) return;

    const controller = new AbortController();

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await api.get(url, {
          signal: controller.signal,
        });

        setData(response.data);

      } catch (err) {
        if (err.name !== 'CanceledError') {
          console.error(err);
          setError(err.message);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    return () => controller.abort();
  }, [url]);

  return { data, loading, error };
};

export default useAPI;